// Vibration utility for triggering phone vibrations
export const vibrate = (pattern = [200, 100, 200]) => {
  // Check if Vibration API is supported
  if (!navigator.vibrate) {
    console.log('Vibration API not supported on this device');
    return false;
  }

  try {
    // Trigger vibration with pattern
    navigator.vibrate(pattern);
    console.log('Vibration triggered with pattern:', pattern);
    return true;
  } catch (error) {
    console.error('Error triggering vibration:', error);
    return false;
  }
};

// Check if we should notify (vibrate and show toast)
export const shouldNotify = (currentChatId, messageChatId) => {
  // Don't notify if we're currently viewing this chat
  if (currentChatId === messageChatId) {
    return false;
  }

  // Always notify if page is hidden
  if (document.hidden) {
    return true;
  }

  // Check if chat section is visible on screen
  const chatElement = document.querySelector('.chat-container, .jukebox-panel');
  if (chatElement) {
    const rect = chatElement.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    return !isVisible;
  }

  return true;
};

// Page visibility change handler
export const setupVisibilityListener = (callback) => {
  const handleVisibilityChange = () => {
    callback(document.hidden);
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);
  
  // Return cleanup function
  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};